/* external (3rd party) fulfiller module */

import uiRouter from '@uirouter/angularjs';

import { AppShellModule } from 'components/appShell/appShell.module';
import { AppsServiceModule } from '../../services/data/apps.service';

import './externalFulfiller.scss';

export const ExternalFulfillerModule = angular
    .module('app.pages.externalFulfiller', [
        uiRouter,
        AppShellModule,
        AppsServiceModule
    ]).config(($stateProvider) => {
        'ngInject';

        $stateProvider.state({
            parent: 'apps',
            name: 'externalfulfiller',
            url: '/externalfulfiller/:redirectAppKey/:orderId/:redirectUrl/:appName',
            component: 'appShell',
            resolve: {
                title: ($transition$) => {
                    const appName = $transition$.params().appName;
                    return decodeURIComponent(appName);
                },
                trackingId: () => {
                    return 'ExternalFulfiller';
                },
                src: ($sce, $q, appsService, $transition$) => {
                    const { redirectAppKey, orderId, redirectUrl } = $transition$.params();
                    return $q.all([appsService.getHmac(), appsService.getAppToken(redirectAppKey)])
                        .then(([hmac, token]) => {
                            const baseUri = decodeURIComponent(redirectUrl);
                            // eslint-disable-next-line max-len
                            const uri = `${baseUri}?tenant=${hmac.tenant}&hmac=${hmac.hmac}&timestamp=${hmac.timestamp}&token=${token}&orderid=${orderId}`;
                            return uri;
                        });
                }
            },
            data: {
                page: 'externalfulfiller'
            }
        });
    }).name;



// WEBPACK FOOTER //
// ./src/app/pages/externalFulfiller/externalFulfiller.module.js